export const ALLOWED_MONTHLY_FIXED_CHARGE_WRITE_OFF_EMAIL = 'jayson@hooraypower.co.za';

export function getUserEmail(user) {
  return user?.email || user?.preferred_username || user?.username || user?.sub || '';
}

export function canAccessMonthlyFixedChargeWriteOff(user) {
  return getUserEmail(user).toLowerCase() === ALLOWED_MONTHLY_FIXED_CHARGE_WRITE_OFF_EMAIL;
}

export function getResolvedUnitUuid(unit) {
  return unit?.unitUuid || unit?.uuid || '';
}

export function getResolvedAccountUuid(account) {
  return account?.accountUuid || account?.uuid || '';
}

export function centsToRands(value) {
  const cents = Number(value ?? 0);

  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(cents / 100);
}

export function canWriteOffCharge(charge) {
  const status = charge?.status;
  const outstandingCents = Number(charge?.amountOutstandingCents ?? 0);

  return (status === 'PENDING' || status === 'PARTIAL') && outstandingCents > 0;
}

export function formatBillingPeriod(period) {
  if (!period) {
    return 'N/A';
  }

  const [year, month] = String(period).split('-');
  const date = new Date(Number(year), Number(month) - 1);

  if (Number.isNaN(date.getTime())) {
    return period;
  }

  return date.toLocaleDateString('en-ZA', {
    year: 'numeric',
    month: 'long',
  });
}

export function formatFixedChargeDate(value) {
  if (!value) {
    return 'N/A';
  }

  const date = new Date(value);

  if (Number.isNaN(date.getTime())) {
    return 'N/A';
  }

  return date.toLocaleString('en-ZA', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}
